// @flow

import common from './locales/el/common.json'

export const el = { common }

export default el
